import { ApiResponse } from "@/types";
import { apiSlice } from "@/redux/apiSlice";
import { BusinessUnit, BusinessUnitTable } from "@/types/system-setting/business-unit";

export const businessUnitApi = apiSlice.injectEndpoints({
    endpoints(builder) {
        return {
            getBusinessUnits: builder.query<
                BusinessUnitTable,
                { org_id: number; search_key?: string; limit?: number; offset?: number; sort_order?: string; sort_key?: string }
            >({
                query: ({ org_id, ...params }) => ({
                    url: `/business-units`,
                    params: { org_id, ...params },
                    method: "GET",
                }),
                providesTags: (result) =>
                    result
                        ? [
                            ...result.data.map(({ id }) => ({ type: "BusinessUnit" as const, id })),
                            { type: "BusinessUnit", id: "LIST" },
                        ]
                        : [{ type: "BusinessUnit", id: "LIST" }],
            }),

            getBusinessUnitById: builder.query<BusinessUnit, { id: number; org_id: number }>({
                query: ({ id, org_id }) => ({
                    url: `/business-units/${id}`,
                    params: { org_id },
                    method: "GET",
                }),
                providesTags: (result, error, { id }) => [{ type: "BusinessUnit", id }],
            }),

            createBusinessUnit: builder.mutation<ApiResponse, Partial<BusinessUnit>>({
                query: (body) => ({
                    url: `/business-units?org_id=${body.org_id}`,
                    method: "POST",
                    body,
                }),
                invalidatesTags: [{ type: "BusinessUnit", id: "LIST" }],
            }),

            updateBusinessUnit: builder.mutation<ApiResponse, { id: number; body: Partial<BusinessUnit> }>({
                query: ({ id, body }) => ({
                    url: `/business-units/${id}?org_id=${body.org_id}`,
                    method: "PUT",
                    body,
                }),
                invalidatesTags: (result, error, { id }) => [
                    { type: "BusinessUnit", id },
                    { type: "BusinessUnit", id: "LIST" },
                ],
            }),

            deleteBusinessUnit: builder.mutation<ApiResponse, { id: number; org_id: number }>({
                query: ({ id, org_id }) => ({
                    url: `/business-units/${id}`,
                    params: { org_id },
                    method: "DELETE",
                }),
                invalidatesTags: [{ type: "BusinessUnit", id: "LIST" }],
            }),
        };
    },
});

export const {
    useGetBusinessUnitsQuery,
    useGetBusinessUnitByIdQuery,
    useCreateBusinessUnitMutation,
    useUpdateBusinessUnitMutation,
    useDeleteBusinessUnitMutation,
} = businessUnitApi;
